import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import styled from 'styled-components'
import 'antd/dist/antd.css'

import App from './App'
import ErrorBoundary from './Components/ErrorBoundary'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import reportWebVitals from './reportWebVitals'
import configureStore from './Stores/configureStore'
import { history } from './Stores/reducers'
import ThemeProvider, { ThemedGlobalStyle } from './Themes'

const VerticalBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`

const initialState = {}
const store = configureStore(initialState, history)

const useLocalStorage = import.meta.env.VITE_USE_LOCAL_STORAGE === 'true'
const root = createRoot(document.getElementById('root'))
root.render(
  import.meta.env.DEV && !useLocalStorage ? (
    <React.StrictMode>
      <ErrorBoundary>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <VerticalBox>
              <ThemeProvider>
                <ThemedGlobalStyle />
                <App />
              </ThemeProvider>
            </VerticalBox>
          </ConnectedRouter>
        </Provider>
      </ErrorBoundary>
    </React.StrictMode>
  ) : import.meta.env.DEV && useLocalStorage ? (
    <ErrorBoundary>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <VerticalBox>
            <ThemeProvider>
              <ThemedGlobalStyle />
              <App />
            </ThemeProvider>
          </VerticalBox>
        </ConnectedRouter>
      </Provider>
    </ErrorBoundary>
  ) : (
    <ErrorBoundary>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <VerticalBox>
            <ThemeProvider>
              <ThemedGlobalStyle />
              <App />
            </ThemeProvider>
          </VerticalBox>
        </ConnectedRouter>
      </Provider>
    </ErrorBoundary>
  )
)

serviceWorkerRegistration.unregister()
reportWebVitals()
